/* Barra de compra fija (mobile). Reutiliza el boton y el formulario reales de la ficha. */
if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      // En el panel de quick add (colecciones) no se usa la barra fija
      if (this.closest('quick-add-modal')) {
        this.remove();
        return;
      }

      const root = this.closest('product-info');
      if (!root) return;
      const form = root.querySelector('product-form');
      const mainBtn = form && form.querySelector('[type="submit"]');
      if (!mainBtn) return;

      this.initialized = true;
      this.root = root;
      this.mainBtn = mainBtn;
      this.labelEl = this.querySelector('[data-satc-label]');
      this.priceEl = this.querySelector('[data-satc-price]');
      this.sizeEl = this.querySelector('[data-satc-size]');
      this.btn = this.querySelector('[data-satc-btn]');
      this.needsSize = !!root.querySelector('variant-selects');
      this.userSelected = new URLSearchParams(window.location.search).has('variant');
      this.pending = false;
      this.visible = false;
      this.shifted = [];
      this.variant = this.readVariant();

      // Limpia barras de una ficha anterior (cambio de producto sin recargar)
      document.querySelectorAll('sticky-atc').forEach((el) => {
        if (el !== this && el.parentElement === document.body) el.remove();
      });
      // Se mueve a body para que ningun ancestro con transform rompa position: fixed
      document.body.appendChild(this);

      this.btn.addEventListener('click', () => this.onClick());

      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(
          subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
            if (data && data.event && !this.root.contains(data.event.target)) return;
            this.userSelected = true;
            this.setPending();
            this.update();
          })
        );
        this.unsubscribers.push(
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            clearTimeout(this.pendingTimer);
            this.pending = false;
            if (data && data.variant) this.variant = data.variant;
            this.update();
          })
        );
      }

      this.mo = new MutationObserver(() => this.update());
      this.mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });

      const priceNode = root.querySelector('[id^="price-"]');
      if (priceNode) {
        this.mo2 = new MutationObserver(() => this.update());
        this.mo2.observe(priceNode, { childList: true, subtree: true, characterData: true });
      }

      this.io = new IntersectionObserver((entries) => this.setVisible(!entries[0].isIntersecting), { threshold: 0 });
      this.io.observe(mainBtn);

      this.update();
    }

    disconnectedCallback() {
      // Mover el elemento a body dispara disconnect + connect: solo limpiamos si de verdad se removio
      queueMicrotask(() => {
        if (!this.isConnected) this.destroy();
      });
    }

    destroy() {
      if (!this.initialized) return;
      this.initialized = false;
      clearTimeout(this.pendingTimer);
      clearTimeout(this.lateTimer);
      (this.unsubscribers || []).forEach((fn) => fn && fn());
      this.mo && this.mo.disconnect();
      this.mo2 && this.mo2.disconnect();
      this.io && this.io.disconnect();
      this.shiftFloaters(false);
      document.body.classList.remove('has-sticky-atc');
    }

    setPending() {
      this.pending = true;
      clearTimeout(this.pendingTimer);
      // Si por algun motivo no llega el evento de variante, no dejamos la barra bloqueada
      this.pendingTimer = setTimeout(() => {
        this.pending = false;
        this.update();
      }, 4000);
    }

    readVariant() {
      const script = this.root.querySelector('variant-selects [data-selected-variant]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    readPrice() {
      const node = this.root.querySelector('[id^="price-"]');
      const price = node && node.querySelector('.price');
      if (!price) return '';
      const onSale = price.classList.contains('price--on-sale');
      const el = onSale
        ? price.querySelector('.price__sale .price-item--sale')
        : price.querySelector('.price__regular .price-item--regular');
      const text = (el || price.querySelector('.price-item') || {}).textContent || '';
      return text
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\s*PEN$/, '')
        .replace(/[.,]00$/, '');
    }

    update() {
      const soldOut = this.mainBtn.hasAttribute('disabled') && !this.pending;
      const loading =
        this.pending ||
        this.mainBtn.getAttribute('aria-disabled') === 'true' ||
        this.mainBtn.classList.contains('loading');

      let label = 'Agregar al carrito';
      if (soldOut) label = 'Agotado';
      else if (this.needsSize && !this.userSelected) label = 'Elegir talla';
      if (this.labelEl.textContent !== label) this.labelEl.textContent = label;

      this.classList.toggle('is-soldout', soldOut);
      this.classList.toggle('is-loading', loading && !soldOut);

      const price = this.readPrice();
      if (price && this.priceEl.textContent !== price) this.priceEl.textContent = price;

      const v = this.variant;
      const size = this.needsSize && this.userSelected && v && v.options ? v.options.join(' / ') : '';
      const sizeText = size ? 'Talla ' + size : '';
      if (this.sizeEl.textContent !== sizeText) this.sizeEl.textContent = sizeText;
    }

    onClick() {
      if (this.classList.contains('is-soldout') || this.classList.contains('is-loading')) return;
      if (this.needsSize && !this.userSelected) {
        this.promptSize();
        return;
      }
      this.mainBtn.click();
    }

    promptSize() {
      const target = this.root.querySelector('variant-selects') || this.root.querySelector('.product-form__input');
      if (!target) return;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      const fieldsets = target.querySelectorAll('fieldset');
      fieldsets.forEach((f) => {
        f.classList.remove('satc-nudge');
        void f.offsetWidth;
        f.classList.add('satc-nudge');
      });
      setTimeout(() => fieldsets.forEach((f) => f.classList.remove('satc-nudge')), 1200);
    }

    setVisible(show) {
      if (show === this.visible) return;
      this.visible = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) this.removeAttribute('inert');
      else this.setAttribute('inert', '');

      document.body.classList.toggle('has-sticky-atc', show);
      if (show) document.documentElement.style.setProperty('--satc-h', this.offsetHeight + 'px');

      this.shiftFloaters(show);
      clearTimeout(this.lateTimer);
      if (show) {
        // Algunos widgets (WhatsApp, etc.) cargan tarde: reintentamos una vez
        this.lateTimer = setTimeout(() => {
          if (this.visible) this.shiftFloaters(true);
        }, 1800);
      }
    }

    // Sube los botones flotantes de la esquina inferior derecha para que no tapen el boton de la barra
    shiftFloaters(show) {
      if (!show) {
        this.shifted.forEach(({ el, transition }) => {
          el.style.translate = '';
          el.style.transition = transition;
        });
        this.shifted = [];
        return;
      }
      if (window.innerWidth >= 750) return;

      const h = this.offsetHeight;
      const x = window.innerWidth - 36;
      const y = window.innerHeight - 36;
      document.elementsFromPoint(x, y).forEach((el) => {
        if (el === this || this.contains(el) || el === document.documentElement || el === document.body) return;
        let node = el;
        while (node && node !== document.body && getComputedStyle(node).position !== 'fixed') {
          node = node.parentElement;
        }
        if (!node || node === document.body || node === this) return;
        if (this.shifted.some((s) => s.el === node)) return;
        this.shifted.push({ el: node, transition: node.style.transition });
        node.style.transition = 'translate 0.35s cubic-bezier(0.22, 0.61, 0.36, 1)';
        node.style.translate = '0 -' + h + 'px';
      });
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}